var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BarChartContainer',{attrs:{"title":_vm.translations('dashboard.sales_budget_actual'),"month-datasets":_vm.monthDatasets,"year-datasets":_vm.yearDatasets,"chart-datalabels":_vm.chartDataLabels}}),_c('vue-element-loading',{attrs:{"active":_vm.isLoading,"color":"#888"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }